import useIsDesktop from "@hooks/useIsDesktop"

import { ButtonProps } from "@atoms/Button/Button.types"
import { Button } from "@atoms/index"

import useOTPForm from "@organisms/OTPForm/OTPForm.store"

export default function OTPVerifyCodeButton(props: Partial<ButtonProps>) {
    const isDesktop = useIsDesktop()

    const { handleCodeVerification, isVerifyingCode } = useOTPForm()

    return (
        <Button
            size={isDesktop ? "sm" : "lg"}
            variant="solid"
            onClick={handleCodeVerification}
            isFullWidth={true}
            isProcessing={isVerifyingCode}
            {...props}
        />
    )
}
